<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase v-bind="$attrs">
    <svg viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2282_25739)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.97757 2.21922C3.27071 1.92658 3.74558 1.92698 4.03823 2.22012L9.2794 7.47013C9.57188 7.7631 9.57168 8.23763 9.27896 8.53034L4.03033 13.779C3.73744 14.0719 3.26256 14.0719 2.96967 13.779C2.67678 13.4861 2.67678 13.0112 2.96967 12.7183L7.68841 7.99957L2.97667 3.27988C2.68403 2.98674 2.68443 2.51187 2.97757 2.21922Z"
          fill="currentColor"
        />
      </g>
    </svg>
  </IconBase>
</template>
